/**
 * STU (Studievaardig) Module Seeds - Consolidated Index
 *
 * Phase H-9: Migrated from flat seed_STU.json to folder-based pattern.
 */

import STU_ALFABET from './STU-ALFABET.json'
import STU_COMBINEER from './STU-COMBINEER.json'
import STU_GRAFIEK from './STU-GRAFIEK.json'
import STU_INHOUDSOPGAVE from './STU-INHOUDSOPGAVE.json'
import STU_KAART from './STU-KAART.json'
import STU_TABEL from './STU-TABEL.json'
import STU_STAAF from './STU-STAAF.json'
import STU_LIJN from './STU-LIJN.json'
import STU_CIRKEL from './STU-CIRKEL.json'

// REMOVED: STU-BRONNEN.json — familyId not in taxonomy (removed in MVP: complex critical thinking)

const STU_FAMILY_SEEDS = [
  { file: 'src/data/seeds/STU/STU-ALFABET.json', data: STU_ALFABET },
  { file: 'src/data/seeds/STU/STU-COMBINEER.json', data: STU_COMBINEER },
  { file: 'src/data/seeds/STU/STU-GRAFIEK.json', data: STU_GRAFIEK },
  {
    file: 'src/data/seeds/STU/STU-INHOUDSOPGAVE.json',
    data: STU_INHOUDSOPGAVE,
  },
  { file: 'src/data/seeds/STU/STU-KAART.json', data: STU_KAART },
  { file: 'src/data/seeds/STU/STU-TABEL.json', data: STU_TABEL },
  { file: 'src/data/seeds/STU/STU-STAAF.json', data: STU_STAAF },
  { file: 'src/data/seeds/STU/STU-LIJN.json', data: STU_LIJN },
  { file: 'src/data/seeds/STU/STU-CIRKEL.json', data: STU_CIRKEL },
] as const

const allQuestions = STU_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question: any) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Studievaardig' as const,
  moduleCode: 'STU',
  version: '5.2-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
